const prefix = "USER::";

export const SET_LOADING = `${prefix}SET_LOADING`;
export const SET_USER_DATA = `${prefix}SET_USER_DATA`;